var FileWrapper = require('filewrapper');
var Message = require('message');
var urlUtil = require('../lib/url.es6');

require('attachment.scss');

// Bind `this` to a formatter instance when using this module

export function render (message, fallback) {
    var attachmentParts = message.getAttachmentsJson().map(attach => {
        return renderOne.call(this, attach, message, fallback);
    });
    return attachmentParts.join('');
}

function limitText(text, limit) {
    var parts = text.split(' ');
    var result = '';
    var i = 0;
    while (parts.length && result.length < limit) {
        if (i > 0) {
            result += ' ';
        }
        result += parts.shift();
        i++;
    }
    return result;
}

function renderOne (attach, message, fallback) {
    var urlToParse = attach.from_url || attach.title_link;
    var suppressImage = false;
    var isSlackAttachment = message.buffer.connection.isSlackOAuth() && attach.service_name == 'Slack';
    if (!message.isAttachmentFallback() && !isSlackAttachment) {
        if (urlToParse) {
            var urlParsed = this.linker.renderUrl(urlToParse, {embeds: true});
            if (urlParsed) {
                switch (urlParsed.className) {
                case 'image':
                case 'instagram':
                case 'imgur':
                case 'xkcd':
                case 'wiki':
                case 'kickstarter video':
                case 'pastebincom':
                case 'video':
                case 'flickr':
                    suppressImage = true;
                    break;
                case 'mastodon':
                case 'reddit':
                case 'bsky':
                    return;
                }
            }
        }
    }
    var attachment = '';
    var hasContent = false;
    if (message.isAttachmentFallback() && fallback) {
        attachment += '<span class="attachFallback">';
        attachment += fallback;
        attachment += '</span>';
    }
    var className = 'attachWrap';
    if (isSlackAttachment) {
        className += ' attachWrap--slack';
    } else {
        className += ' attachWrap--external';
    }
    var hasSnippet = false;
    if (_.isString(attach.snippet_preview) && attach.snippet_preview.length) {
        hasSnippet = true;
        className += ' attachWrap--snippet';
    }
    attachment += '<span class="' + className + '">';

    if (attach.pretext) {
        hasContent = true;
        attachment += '<span class="attachment__pretext">';
        attachment += this.renderLinkify(attach.pretext, {
            replacements: Message.getCustomEmoji(attach.pretext_emoji)
        });
        attachment += '</span>';
    }

    var attrs = {
        "class": "attachment"
    };
    if (attach.color) {
        attrs.style = 'border-color: #' + this.escapeText(attach.color);
    }
    attachment += '<span' + this.makeAttributes(attrs) + '>';

    attachment += '<a href="" class="attachmentClose" title="Close attachment">close</a>';

    var imageAllowed = isSlackAttachment || message.buffer.inlineImagesAllowed();
    var imageTag = imageAllowed ? 'img' : 'i';
    var sourceImageTag = message.buffer.inlineImagesAllowed() ? 'img' : 'i';

    if (!suppressImage && attach.thumb_url) {
        hasContent = true;
        // 75x75 max
        attachment += '<' + imageTag + this.makeAttributes({'class': 'attachment__thumb image loading', src: urlUtil.toHttps(attach.thumb_url)}) + '></' + imageTag + '>';
    }

    if (attach.author_name || attach.author_subname || attach.service_name) {
        hasContent = true;
        attachment += '<span class="attachment__source">';

        var source_icon = attach.author_icon || attach.service_icon;
        if (source_icon) {
            // 16x16
            attachment += '<' + sourceImageTag + this.makeAttributes({
                'class': 'attachment__source_icon image loading',
                src: urlUtil.toHttps(source_icon),
                width: 16,
                height: 16
            }) + '></' + sourceImageTag + '>';
        }

        var source;
        if (attach.service_name && attach.service_icon && !attach.author_icon && !attach.author_subname) {
            attachment += '<span class="attachment__source_name">';
            source = this.escapeText(attach.service_name);
            var source_url = attach.service_url;
            if (source_url) {
                attachment += this.linker.make(source, {
                    href: source_url,
                    target: '_blank',
                    rel: 'noreferrer'
                });
            } else {
                attachment += source;
            }
            attachment += '</span>';
        }

        if (attach.author_name || attach.author_subname) {
            if (source) {
                attachment += ' | ';
            }
            attachment += '<span class="attachment__author">';
            if (attach.service_name == 'Slack message' && attach.author_name) {
                attachment += this.linkNick(attach.author_name);
                if (attach.author_subname && attach.author_subname != attach.author_name) {
                    attachment += '&nbsp;';
                    attachment += '<span class="attachment__author_realname">';
                    attachment += this.renderLinkify(attach.author_subname);
                    attachment += '</span>';
                }
            } else {
                if (attach.author_name) {
                    var author = this.escapeText(attach.author_name);
                    if (attach.author_link) {
                        attachment += this.linker.make(author, {
                            href: attach.author_link,
                            target: '_blank',
                            rel: 'noreferrer'
                        });
                    } else {
                        attachment += author;
                    }
                }
                if (attach.author_subname) {
                    if (attach.author_name) {
                        attachment += ' | ';
                    }
                    var author_sub = this.escapeText(attach.author_subname);
                    if (attach.author_link && !attach.author_name) {
                        attachment += this.linker.make(author_sub, {
                            href: attach.author_link,
                            target: '_blank',
                            rel: 'noreferrer'
                        });
                    } else {
                        attachment += author_sub;
                    }
                }
            }
            attachment += '</span>';
        }
        attachment += '</span>';
    }

    if (
        _.isString(attach.title) && attach.title.length &&
        (attach.title.toLowerCase() != 'untitled' || attach.file_url || attach.title_link)
    ) {
        hasContent = true;
        var title = this.renderEmoji(this.escapeText(attach.title.trim()));
        attachment += '<span class="attachment__title">';
        if (attach.file_url || attach.title_link) {
            attachment += this.linker.make(title, {
                href: attach.file_url || attach.title_link,
                target: '_blank',
                rel: 'noreferrer'
            });
        } else {
            attachment += title;
        }
        attachment += '</span>';
    }

    if (hasSnippet) {
        hasContent = true;
        attachment += '<span class="attachment__snippet-title">';
        if (_.isString(attach.snippet_type) && attach.snippet_type.length) {
            attachment += this.escapeText(attach.snippet_type.trim()) + ' snippet';
        } else {
            attachment += 'Snippet';
        }
        attachment += '</span>';
        attachment += '<pre' + this.makeAttributes({
            'class': 'attachment__snippet',
            data: {
                name: attach.title,
                filename: attach.snippet_filename,
                url: attach.title_link,
                lines: attach.snippet_lines,
                preview_lines: attach.snippet_preview_lines,
                ts: attach.ts,
                size: attach.snippet_bytes,
                service_url: attach.service_url,
                service_name: attach.service_name,
                raw_url: attach.snippet_raw
            }
        }) + '>';
        attachment += this.escapeText(attach.snippet_preview);
        attachment += '</pre>';
    }

    if (_.isString(attach.text) && attach.text.length) {
        hasContent = true;
        var text = limitText(attach.text, 500);
        attachment += '<div class="attachment__text">';
        attachment += '<div class="attachment__text-snippet">';
        attachment += this.renderLinkify(text, {
            replacements: Message.getCustomEmoji(attach.text_emoji),
            codeSpan: message.buffer.formatCodeSpan(),
            codeBlock: message.buffer.formatCodeBlock(),
            quote: message.buffer.formatQuote()
        });
        attachment += '</div>';
        if (text.length < attach.text.length) {
            attachment += '<a href="" class="attachment__text-toggle attachment__text-more">See more…</a>';
            attachment += '<div class="attachment__text-full">';
            attachment += this.renderLinkify(attach.text, {
                replacements: Message.getCustomEmoji(attach.text_emoji),
                codeSpan: message.buffer.formatCodeSpan(),
                codeBlock: message.buffer.formatCodeBlock(),
                quote: message.buffer.formatQuote()
            });
            attachment += '</div>';
            attachment += '<a href="" class="attachment__text-toggle attachment__text-less">See less…</a>';
        }
        attachment += '</div>';
    }

    if (_.isArray(attach.fields) && attach.fields.length) {
        attachment += '<span class="attachment__fields">';
        attach.fields.forEach(field => {
            if (field.title || field.value) {
                hasContent = true;
                var fieldClassNames = 'attachment__field';
                if (field.short) {
                    fieldClassNames += ' attachment__field--short';
                }
                var f = '<span' + this.makeAttributes({'class': fieldClassNames}) + '>';
                if (field.title) {
                    f += '<h3 class="attachment__field-title">' + this.renderEmoji(this.escapeText(field.title)) + '</h3>';
                }
                if (field.value) {
                    f += '<div class="attachment__field-value">' + this.renderLinkify(field.value, {
                        replacements: Message.getCustomEmoji(field.emoji)
                    }) + '</div>';
                }
                f += '</span>';
                attachment += f;
            }
        });
        attachment += '</span>';
    }

    var hasImage = !suppressImage && !!attach.image_url && !!attach.image_width && !!attach.image_height;

    if (attach.footer || attach.ts || (hasImage && attach.image_bytes) || (attach.file_url && attach.title_link)) {
        hasContent = true;
        attachment += '<span class="attachment__footer">';
        if (attach.footer_icon) {
            // 16x16
            attachment += '<' + sourceImageTag + this.makeAttributes({
                'class': 'attachment__footer_icon image loading',
                src: urlUtil.toHttps(attach.footer_icon),
                width: 16,
                height: 16
            }) + '></' + sourceImageTag + '>';
        }
        if (attach.footer) {
            attachment += '<span class="attachment__footer_label">';
            attachment += this.renderLinkify(attach.footer);
            attachment += '</span> ';
        }
        if (attach.ts) {
            var date = new Date(attach.ts*1000);
            if (date instanceof Date && !isNaN(date.getTime())) {
                if (attach.footer) {
                    attachment += '| ';
                }
                var ts = date.formatFullDate();
                attachment += '<span class="attachment__footer_ts">';
                if (attach.from_url) {
                    attachment += this.linker.make(ts, {
                        href: attach.from_url,
                        target: '_blank',
                        rel: 'noreferrer'
                    });
                } else {
                    attachment += ts;
                }
                attachment += '</span> ';
            }
        }
        if (attach.image_bytes) {
            attachment += '<span class="attachment__footer_bytes">(';
            attachment += FileWrapper.sizeToString(attach.image_bytes);
            attachment += ')</span> ';
        }
        if (attach.file_url && attach.title_link) {
            attachment += '<span class="attachment__footer_file">';
            attachment += this.linker.make("source", {
                href: attach.title_link,
                target: '_blank',
                rel: 'noreferrer'
            });
            attachment += '</span>';
        }
        attachment += '</span>';
    }

    if (hasImage) {
        hasContent = true;
        // 400x500 max
        var image = '<' + imageTag + this.makeAttributes({
            'class': 'attachment__image_img image loading',
            src: urlUtil.toHttps(attach.image_url),
            width: attach.image_width,
            height: attach.image_height
        }) + '></' + imageTag + '>';
        attachment += '<span class="attachment__image">';
        attachment += this.linker.make(image, {
            'class': 'attachment__image_link',
            href: attach.file_url || attach.image_url,
            target: '_blank',
            rel: 'noreferrer'
        });
        attachment += '</span>';
    }

    attachment += '</span>';
    attachment += '</span>';

    if (hasContent) {
        return attachment;
    }
}



// WEBPACK FOOTER //
// ./app/src/format/attachment.es6